import { forwardRef } from 'react';
import styled from 'styled-components';
import { Icon, ListItem, Toggle, Tooltip } from '@optimus-web/core';
import HandleMenuItem from '../Handles/HandleMenuItem';

// @ts-expect-error $TSFixMeError: No overload matches this call.
const TooltipWrapper = Tooltip(forwardRef((props, ref) => <StyledDiv {...props} ref={ref} />));

interface Props {
    action?: {
        label?: React.ReactNode;
        value?: boolean;
        withLabel?: boolean;
        onIconName?: string;
        offIconName?: string;
        onChange?: $TSFixMeFunction;
    };
}

const ToggleSwitchAction = (props: Props) => {
    // @ts-expect-error $TSFixMeError: Property 'value' does not exist on type '{ label?: ReactNode; value?: boolean | undefined; withLabel?: boolean | undefin...
    const { value, offBackgroundIcon, onBackgroundIcon, onChange, text, disabled } = props.action;

    const switchProps = {
        checked: value,
        onChange,
        offBackgroundIcon,
        onBackgroundIcon,
        disabled,
    };

    return (props as $TSFixMe).component === HandleMenuItem ? (
        <ListItem
            leftIcon={<Icon value={value ? onBackgroundIcon : offBackgroundIcon} />}
            primaryText={text}
            onClick={onChange}
            data-test-switch
        />
    ) : (
        <TooltipWrapper tooltip={text} data-test-switch>
            <Toggle {...switchProps} />
        </TooltipWrapper>
    );
};

const StyledDiv = styled.div`
    height: 48px;
    width: 48px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default ToggleSwitchAction;
